export default "__VITE_ASSET__70b10e67__"